var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        "task-prop",
        "task-prop_date",
        { "task-prop_disabled": this.disabled },
      ],
    },
    [
      _c("strong", { staticClass: "task-prop__label" }, [
        _vm._v(_vm._s(_vm.label)),
      ]),
      _vm._v(" "),
      _vm.disabled
        ? _c("div", { staticClass: "task-prop__value component--select" }, [
            _c(
              "div",
              {
                staticClass: "placeholder placeholder_inline placeholder_icon",
                staticStyle: { cursor: "default" },
              },
              [
                _vm._v(
                  "\n            " + _vm._s(_vm.formattedDate) + "\n        "
                ),
              ]
            ),
          ])
        : _c("Calendar", {
            staticClass: "task-prop__value component--select",
            attrs: { value: _vm.value || new Date() },
            on: { input: (v) => _vm.$emit("update", v) },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }